import React, { useState } from "react";
import { motion } from "framer-motion";
import AdminReceptionistPersonalProfile from "./AdminReceptionistPersonalProfile";

const AdminReceptionistProfile = () => {
  // State to track which tab is selected (0: Personal Details)
  const [activeTab, setActiveTab] = useState(0);

  // Function to switch tabs
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-300 my-6">
        <button
          className={`py-3 px-6 text-lg font-semibold ${
            activeTab === 0
              ? "text-blue-600 border-b-4 border-blue-600"
              : "text-gray-600 hover:text-blue-600"
          } transition-colors duration-300`}
          onClick={() => handleTabClick(0)}
        >
          Personal Details
        </button>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 0 && <AdminReceptionistPersonalProfile />}
      </div>
    </motion.div>
  );
};

export default AdminReceptionistProfile;